import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import IconLink from '../IconLink';
import HomeRedirectLogo from './homeRedirectLogo.svg'
import LogoutLogo from './logout.svg'
import Logo from './Medi-Cal_Rx-logo.png'

import {faUserMd} from '@fortawesome/free-solid-svg-icons'

import messages from "./utils";

import useStyles from "./styles";
import AppContext from "../../contexts/App/App.context";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getHomeUrl, getContactUrl} from '../../shared/okta.helper'

export default function Header() {
    const classes = useStyles()
    const {provider, npiNumber, isLoggedIn, logout} = useContext(AppContext);
    const {id, navBars, caLogo} = messages
    return (
        <header id={id} data-testid={id}>

            <div className={classes.root}>

                <Grid container className={classes.headerTop} justify='flex-end'>
                    <Grid
                        item xs={12}
                        container alignItems="center" justify="flex-end"
                        className={classes.headerTypography}
                    >
                        { isLoggedIn() &&
                            <>
                                <Grid item className={classes.homeLinkWrapper}>
                                    <span>
                                        <img src={HomeRedirectLogo} alt='Main Portal' className={classes.homeRedirectIcon} />
                                        <a className={classes.homeLink} href={getHomeUrl()}>Back to Dashboard</a>
                                    </span>
                                </Grid>
                                <Grid item>
                                    <span id="MEDCAL_RX_NAV_PERSON_ICON" data-testid="MEDCAL_RX_NAV_PERSON_ICON">
                                    <FontAwesomeIcon icon={faUserMd} className={classes.personaIcon}/>
                                    </span>
                                </Grid>
                                <Grid item className={classes.npiWrapper}>
                                    { provider &&
                                        <span
                                            className={classes.npi}
                                            id="MEDCAL_RX_NAV_USERNAME"
                                            data-testid="MEDCAL_RX_NAV_USERNAME"
                                        >
                                            {`${provider.providerFirstName ? provider.providerFirstName : ''}${provider.providerFirstName ? ' ' : ''}${provider.providerLastName ? provider.providerLastName : ''}`}
                                        </span>
                                    }
                                    {npiNumber && <span className={classes.npi} id="MEDCAL_RX_NAV_NPI" data-testid="MEDCAL_RX_NAV_NPI"> (NPI:{npiNumber})</span>}
                                </Grid>

                            </>
                        }
                        <Grid item className={classes.contactLinkWrapper}>
                            <a href={getContactUrl()} id="MEDCAL_RX_NAV_CONTACT_LINK" data-testid="MEDCAL_RX_NAV_CONTACT_LINK" className={classes.contactLink}>
                                Contact Us
                            </a>
                        </Grid>
                        <Grid item>
                            <div className={classes.langWrapper} id="MEDCAL_RX_GOOGLE_TRANSLATE" data-testid="MEDCAL_RX_GOOGLE_TRANSLATE">
                                <div id="google_translate_element"></div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container className={classes.headerBottom}>
                    <Grid item className={classes.headerBottomDHCSLogo}>
                        <div id={caLogo.id}>
                            <Link to='/'>
                                <img src={Logo} alt={caLogo.text} className={classes.dhcsLogo}/>
                            </Link>
                        </div>
                    </Grid>
                    <Grid item className={classes.headerBottomNavLinksWrapper}>
                        <Grid
                            container
                            justify="flex-end"
                            spacing={3}
                            className={classes.headerBottomNavLinksContent}>
                            {isLoggedIn() &&
                            <Grid onClick={logout} className={classes.logout} item>
                                <IconLink
                                    icon={LogoutLogo}
                                    text={navBars.bottom.logout.text}
                                    size='2x'
                                    id={navBars.bottom.logout.id}
                                    type='img'
                                />
                            </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </header>
    )
}
